import { connect } from 'react-redux';
import Header from '../../components/Header/Header';

const mapStateToProps = ({ account }) => {
  const { isLogin, userName } = account;
  return {
    isLogin,
    userName
  };
};

export default connect(mapStateToProps)(Header);
